import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../api';

export default function Verify() {
  const [searchParams] = useSearchParams();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('No token found in the link.');
      return;
    }

    api.get(`/auth/verify?token=${token}`)
      .then(res => {
        login(res.data.token);
        setStatus('success');
        setTimeout(() => navigate('/'), 2000);
      })
      .catch(err => {
        setStatus('error');
        setMessage(err.response?.data?.error || 'Verification failed.');
      });
  }, []);

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        {status === 'verifying' && (
          <>
            <div style={styles.spinner}>⏳</div>
            <h2 style={styles.title}>Verifying your email...</h2>
          </>
        )}
        {status === 'success' && (
          <>
            <div style={styles.icon}>✅</div>
            <h2 style={styles.title}>You're in!</h2>
            <p style={styles.sub}>Redirecting you to the ideas board...</p>
          </>
        )}
        {status === 'error' && (
          <>
            <div style={styles.icon}>❌</div>
            <h2 style={styles.title}>Verification failed</h2>
            <p style={styles.sub}>{message}</p>
            <button onClick={() => navigate('/')} style={styles.btn}>
              Go back home
            </button>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    background: '#f9fafb',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  card: {
    background: '#ffffff',
    border: '1px solid #e5e7eb',
    borderRadius: '12px',
    padding: '48px',
    textAlign: 'center',
    maxWidth: '400px',
    width: '100%',
  },
  icon: {
    fontSize: '48px',
    marginBottom: '16px',
  },
  spinner: {
    fontSize: '48px',
    marginBottom: '16px',
  },
  title: {
    fontSize: '24px',
    fontWeight: '700',
    color: '#111827',
    margin: '0 0 12px 0',
  },
  sub: {
    fontSize: '15px',
    color: '#6b7280',
    margin: '0 0 24px 0',
  },
  btn: {
    padding: '10px 24px',
    borderRadius: '6px',
    border: 'none',
    background: '#2563eb',
    color: '#ffffff',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
  },
};